import React, { FC } from 'react'
import { Card, styled } from '~/app/components'
import { SERVICE_TYPE } from '~/app/utils/OrderListUtils'
import OrderCardItem from '~/app/components/order-list/common/OrderCardItem'
import { CategoryType, PropertyCategory } from '~/__generated__/__types__'
import { TConvertedProductInfo } from '~/app/components/order-converter/converter/DomesticOrderConverter'
import { TConfigBadgeType } from '~/api/utils/leisure'
import PendingReservationNotice from '~/app/components/order-list/common/PendingReservationNotice'
import { ConvertedOrder } from '../order-converter/getCartOrderConverter'

/**
 * SharedOrderListCardItem component
 * author: soojin.oh
 */

// type definitions
export type SharedOrderProps = {
  categoryOrderId: string
  title: string
  subTitle: string
  ratePlanTitle?: string
  serviceType: SERVICE_TYPE
  imageSrc?: string
  info?: TConvertedProductInfo
  options?: string
  id: string
  categoryType?: CategoryType
  isPendingReservation?: boolean
  badges?: TConfigBadgeType[]
  propertyCategory?: PropertyCategory
} & Pick<ConvertedOrder, 'optionTitle'>
type Props = {
  order: SharedOrderProps
  clickable?: boolean
  hasDetailButton?: boolean
  onCardClick?: (serviceType: SERVICE_TYPE, id: string, categoryType?: CategoryType) => void
  id?: string
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div`
  margin: 1rem;
`
const SharedOrderListCard = styled(Card)`
  border: 0.1rem solid ${({ theme }) => theme.color.gray200};
`
const ShareOrderCardItem = styled(OrderCardItem)`
  padding: 2rem;
`

const SharedOrderPendingReservationNotice = styled(PendingReservationNotice)`
  text-align: center;
  padding: 1.6rem 0;
  margin: 0 2.4rem;
  width: 100%;
  border: none;
  border-top: 0.1rem solid ${({ theme }) => theme.color.gray200};
  border-radius: 0;
  background-color: ${({ theme }) => theme.color.white};
`

// SharedOrderListCardItem component
const SharedOrderListCardItem: FC<Props> = function ({
  order,
  onCardClick,
  hasDetailButton = true,
  style,
  clickable = false,
}) {
  const {
    title,
    subTitle,
    ratePlanTitle,
    imageSrc,
    info,
    options,
    serviceType,
    id,
    categoryType,
    categoryOrderId,
    isPendingReservation,
    badges,
    optionTitle,
  } = order

  return (
    <Container onClick={_ => onCardClick?.(serviceType, id, categoryType)} style={style}>
      <SharedOrderListCard>
        <ShareOrderCardItem
          id={id}
          categoryOrderId={categoryOrderId}
          title={title}
          subTitle={subTitle}
          optionTitle={optionTitle}
          ratePlanTitle={ratePlanTitle}
          info={info}
          options={options}
          imageSrc={imageSrc}
          hasDetailButton={hasDetailButton}
          serviceType={order.serviceType}
          categoryType={order.categoryType}
          hideServiceType={true}
          isSharePage={true}
          className={clickable ? 'clickable' : ''}
          badges={badges}
        />
        {isPendingReservation && <SharedOrderPendingReservationNotice />}
      </SharedOrderListCard>
    </Container>
  )
}

export default SharedOrderListCardItem
